import React, { useMemo } from 'react';
import Page from 'src/components/Page';
import { Box, Container } from '@material-ui/core';
import PropTypes from 'prop-types';
import * as breadcrumbs from 'src/utils/breakcrumbs';
import { useParams } from 'react-router-dom';
import ContactForm from './form/ContactForm';

const UserFormView = ({ title }) => {
  const { id } = useParams();
  const pageBreadcrumbs = useMemo(
    () =>
      breadcrumbs.buildWithDashboard([
        {
          link: '/app/contactMesssages/',
          label: ' Contact Messages',
        },
        {
          label: ` view   Contact Messages`,
        },
      ]),
    []
  );

  return (
    <Page title={title} breadcrumbs={pageBreadcrumbs}>
      <Container maxWidth="lg">
        <Box>
          <ContactForm editId={id} />
        </Box>
      </Container>
    </Page>
  );
};

UserFormView.propTypes = {
  title: PropTypes.string.isRequired,
};

export default UserFormView;
